import CorporatePage from '../../components/CorporatePage'
import { CORPORATE_I18N } from '../../data/corporate-i18n'

// Anchor ids match the EXISTING navbar corporate-dropdown hrefs (DE).
const ANCHORS = {
    about: 'about',
    vision: 'vision',
    values: 'werte',
    quality: 'qualitaet',
    certifications: 'zertifikate'
}

const LANG_LINKS = { tr: '/kurumsal', en: '/en/corporate', de: '/de/unternehmen' }

const JSON_LD = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: CORPORATE_I18N.de.seo.title,
    description: CORPORATE_I18N.de.seo.description,
    url: 'https://ankaplastik.com/de/unternehmen',
    inLanguage: 'de',
    about: {
        '@type': 'Organization',
        '@id': 'https://ankaplastik.com/#organization',
        name: 'Ankaplastik'
    }
}

export default function Unternehmen() {
    return (
        <CorporatePage
            lang="de"
            data={CORPORATE_I18N.de}
            langLinks={LANG_LINKS}
            canonicalUrl="/de/unternehmen"
            contactHref="/de#contact"
            skipLabel="Zum Inhalt springen"
            anchors={ANCHORS}
            jsonLd={JSON_LD}
        />
    )
}
